import React from 'react'
import useWindowSize from 'shared/hooks/use-window-size'

interface EventsSkeletonInterface {
  revenueLength: number
}

const EventsSkeleton = ({ revenueLength }: EventsSkeletonInterface) => {
  const { width } = useWindowSize()
  return (
    <>
      <div className={`flex flex-col px-[25px]`}>
        {Array.from(Array(8).keys()).map((el, idx) => (
          <div key={idx}>
            <hr className={'color-text-primary opacity-10'} />
            <div className={'flex flex gap-2 py-4'}>
              <div
                className={
                  'bg-skeleton-primary flex h-[24px] min-w-[24px] animate-pulse rounded-full text-transparent'
                }
              >
                .
              </div>
              <div className={'flex w-full flex-col gap-1'}>
                <div className={'flex items-center justify-between'}>
                  <div
                    className={
                      'bg-skeleton-primary w-[80px] animate-pulse rounded-md text-transparent'
                    }
                  >
                    .
                  </div>
                  <div
                    className={
                      'bg-skeleton-primary h-[20.4px] w-[100px] animate-pulse rounded-md text-transparent'
                    }
                  >
                    .
                  </div>
                </div>
                <div
                  className={
                    'bg-skeleton-primary h-[21.7px] animate-pulse rounded-md text-transparent'
                  }
                >
                  .
                </div>
              </div>
            </div>
          </div>
        ))}
        {revenueLength > 3 &&
          Array.from(Array(width > 1023 && width < 1150 ? 13 : 4).keys()).map((el, idx) => (
            <div key={idx}>
              <hr className={'color-text-primary opacity-10'} />
              <div className={'flex flex gap-2 py-4'}>
                <div
                  className={
                    'bg-skeleton-primary flex h-[24px] min-w-[24px] animate-pulse rounded-full text-transparent'
                  }
                >
                  .
                </div>
                <div className={'flex w-full flex-col gap-1'}>
                  <div className={'flex items-center justify-between'}>
                    <div
                      className={
                        'bg-skeleton-primary w-[80px] animate-pulse rounded-md text-transparent'
                      }
                    >
                      .
                    </div>
                    <div
                      className={
                        'bg-skeleton-primary h-[20.4px] w-[100px] animate-pulse rounded-md text-transparent'
                      }
                    >
                      .
                    </div>
                  </div>
                  <div
                    className={
                      'bg-skeleton-primary h-[21.7px] animate-pulse rounded-md text-transparent'
                    }
                  >
                    .
                  </div>
                </div>
              </div>
            </div>
          ))}
      </div>
    </>
  )
}
export default EventsSkeleton
